import { Button, Text } from '@change/ds-core-ui/next';

import { useSlideUpForm } from './hooks/useSlideUpForm';

type Props = Parameters<typeof useSlideUpForm>[0];

export const Variant1: React.FC<Props> = (props) => {
	const {
		data: { localizedAmount, loading, headline },
		actions: { clickAccept, clickDecline, clickAcceptDifferentAmount },
	} = useSlideUpForm(props);
	return (
		<div className="flex w-full flex-col gap-7 px-1 pb-2 pt-4">
			<div className="flex flex-col gap-3">
				<Text variant="heading" size="small">
					{headline}
				</Text>
				<Text variant="body">Monthly support is the best way to keep Change.org free.</Text>
			</div>
			<div className="flex flex-col gap-3">
				<div className="flex flex-row gap-4">
					<Button className="flex-1" onClick={clickAccept} variant="primary" disabled={loading}>
						<Text fontWeight="bold" variant="heading" size="x-small" className="whitespace-normal">
							Yes, I’ll give {localizedAmount} monthly
						</Text>
					</Button>
					<Button className="flex-1" onClick={clickDecline} variant="primary" disabled={loading}>
						<Text fontWeight="bold" variant="heading" size="x-small" className="whitespace-normal">
							No, thanks
						</Text>
					</Button>
				</div>
				<div className="text-center">
					<Button onClick={clickAcceptDifferentAmount} variant="tertiary" disabled={loading}>
						<Text fontWeight="bold" variant="heading" size="x-small" className="whitespace-normal">
							Yes, I’ll give a different amount monthly
						</Text>
					</Button>
				</div>
			</div>
		</div>
	);
};
